import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Smaller, Bigger } from '../layout/mediaquery';
import { selectSplashtechEligible, showSplashtech, fetcSpashtechEligible } from './ducks/splashtech-duck';
import { authenticationSelector } from '../authentication/ducks/selectors';
import { FilterLink } from '../header/filters';
import LinkList from '~/components/misc/link-list';
import { Icons, ICON_FOOTBALL_LINE as ICON_FOOTBALL } from '~/components/menu-global/icons';
import { SplashtechAppDispatch } from './ducks/types';
import useTranslations from '../translation/use-translations';
import { TEXT_KEYS } from '~/components/marketplace/marketplace-constants';
import useLoginFlow from '~/hooks/use-login-flow';
import { useCloseContextForLocation } from '../../hooks/use-close-context';
import { ROUTE_PROMOTIONS, ROUTE_GLOBAL } from '../router/constants';
import { selectLicense } from '../brand/ducks/selectors';
import { LICENSE_DEGA } from '~/utils/license-utils';
import { selectEnableSplashtechNewBadge } from '../brand/ducks';

type ContentProps = {
	product: string;
	badge: React.Component;
};

const SplashtechGlobalLinks = ({ product, badge }: ContentProps) => {
	const authenticated = useSelector(authenticationSelector);
	const splashtechEligible = useSelector(selectSplashtechEligible) as boolean;
	const showNewTag = useSelector(selectEnableSplashtechNewBadge); //eslint-disable-line
	const dispatch: SplashtechAppDispatch = useDispatch();
	const { translations, isLoadingTranslations } = useTranslations(TEXT_KEYS);
	const { initializeLogin } = useLoginFlow();
	const closeGlobalNav = useCloseContextForLocation(ROUTE_GLOBAL);
	const license = useSelector(selectLicense);
	const isDEGALicense = license === LICENSE_DEGA;

	useEffect(() => {
		if (!splashtechEligible && authenticated) {
			dispatch(fetcSpashtechEligible());
		}
	}, [splashtechEligible, dispatch, authenticated]);

	const clickHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		event.preventDefault();
		event.stopPropagation();
		if (isDEGALicense) closeGlobalNav();
		if (!authenticated) {
			if (!isDEGALicense) closeGlobalNav();
			initializeLogin({
				options: { preserveSidebarState: false, preserveContexts: false },
				from: ROUTE_PROMOTIONS
			});
		} else {
			dispatch(showSplashtech());
		}
	};

	if (isLoadingTranslations) return false;
	return (
		<>
			<Smaller>
				<LinkList
					dataAt="global-menu-item-splash-tech"
					className="at-splash-tech"
					onClick={clickHandler}
					title={translations.MARKETPLACE_SPLASHTECH_ITEM_CARD_TITLE}
					subTitle={translations.MARKETPLACE_SPLASHTECH_ITEM_CARD_SUBTITLE}
					PrimaryIcon={Icons ? Icons[ICON_FOOTBALL] : null}
					badge={showNewTag ? badge : null}
				/>
			</Smaller>
			<Bigger>
				<FilterLink
					key={`navbar-${product}`}
					data-at="global-menu-item-splash-tech"
					onClick={clickHandler}
					href=""
				>
					{translations.MARKETPLACE_SPLASHTECH_ITEM_CARD_TITLE}
					{badge && showNewTag && badge}
				</FilterLink>
			</Bigger>
		</>
	);
};

export default SplashtechGlobalLinks;
